module.exports = __webpack_public_path__ + "bradavice_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_4_before.jpg
// module id = 936
// module chunks = 0